export const HandleQueryErrorKeys = {
  unknown: 'errors.unknown',
  forbidden: 'errors.forbidden',
  notFound: 'errors.notFound',
  connection: 'errors.connection',
};
